import { Badge, BadgeTier, UserBadge } from '@vae/server/dist/client'
import React, { FC, useContext } from 'react'
import { ModalContext } from '../../../contexts/ModalContext'
import i18n from '../../../i18n'
import { useBadgeImage } from '../hooks/useBadgeImage'
import { TierData } from '../types/tierData'

interface BadgeComponentProps {
	badge: Badge
	userBadge?: UserBadge
	tier: BadgeTier
	isClickable?: boolean
	isCompleted?: boolean
}

const BadgeComponent: FC<BadgeComponentProps> = ({
	badge,
	userBadge,
	tier,
	isClickable = false,
	isCompleted = false,
}) => {
	const { insertModal } = useContext(ModalContext)

	const { imagePath, imageLoaded, isLoading } = useBadgeImage(badge.category, tier.tierLevel)

	const handleTierClick = (tierData: TierData) => {
		if (tierData.isCompleted && isClickable) {
			insertModal('badges-detail', tierData)
		}
	}

	const badgeName = i18n.language === 'en' ? badge.nameEn : badge.nameFi

	if (isLoading) {
		return (
			<div
				className={`h-full w-full bg-gray-300 rounded-full flex flex-col gap-1 justify-center items-center animate-pulse`}
			/>
		)
	}

	if (imagePath && imageLoaded) {
		return (
			<img
				className={`h-full w-full ${!isCompleted ? ' grayscale' : ''}`}
				onClick={() => handleTierClick({ badge, tier, isCompleted, userBadge })}
				src={imagePath}
				alt={badgeName}
			/>
		)
	}

	return (
		<div className='rounded-full bg-white p-4 shadow-md'>
			<div
				className={`h-full w-full rounded-full flex flex-col gap-1 justify-center items-center ${isCompleted ? 'bg-green-400' : 'bg-gray-400'}${isClickable ? ' cursor-pointer' : ''}`}
				onClick={() => handleTierClick({ badge, tier, isCompleted, userBadge })}
			>
				<span className='text-sm'>{badgeName}</span>
				<span className='text-xs text-gray-600'>
					{i18n.language === 'en' ? tier.tierNameEn : tier.tierNameFi}
				</span>
			</div>
		</div>
	)
}

export default BadgeComponent
